const String = () => (
  <>
    <path
      fill="currentColor"
      d="M8.556 19a.62.62 0 0 1-.445-.18.58.58 0 0 1-.188-.436V6.25H3.635a.61.61 0 0 1-.45-.184A.6.6 0 0 1 3 5.619q0-.263.18-.441A.6.6 0 0 1 3.615 5h9.846a.62.62 0 0 1 .45.18q.185.18.185.438 0 .257-.18.444a.58.58 0 0 1-.435.188H9.173v12.116q0 .264-.18.449a.59.59 0 0 1-.437.185m8.865 0a.6.6 0 0 1-.436-.18.6.6 0 0 1-.177-.436v-7.23H14.48a.61.61 0 0 1-.45-.184.6.6 0 0 1-.185-.447q0-.264.18-.441a.6.6 0 0 1 .435-.178h5.905a.62.62 0 0 1 .449.18q.185.18.185.438 0 .257-.18.444a.58.58 0 0 1-.436.188h-2.346v7.23q0 .257-.18.436a.6.6 0 0 1-.437.18"
    />
  </>
)
export default String
